<template>
  <div class="page" v-loading="listLoading">
    <!--    批量提交采购   batchPurchase-->
    <!--    提交采购  handlePurchase-->
    <!--    订单详情   orderDetail-->
    <!--    查看物流   checkLogistics-->
    <!--    更改物流   updateLogistics-->
    <div class="form-box">
      <el-form @submit.native.prevent label-width="100px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="子订单号:">
              <el-input v-model="searchData.orderNo" placeholder="子订单号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="商品名称:">
              <el-input v-model="searchData.productSkuName" placeholder="请输入商品名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="收货人姓名:">
              <el-input v-model="searchData.receivingName" placeholder="收货人姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="收货人电话:">
              <el-input v-model="searchData.receivingMobile" placeholder="收货人电话"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="供应商：">
              <el-autocomplete v-model="searchData.supplierName" :fetch-suggestions="querySearchAsync"
                placeholder="请选择供应商 可搜索" @select="handleSelect" style="width:100%"></el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="外部订单号">
              <el-input v-model="searchData.OutOrderNo" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="下单时间">
              <el-date-picker v-model="datePicker" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="handlePicker"
                style="width:100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <div style="display: flex;">
            <el-button type="primary" @click="searchFun">查询</el-button>
            <el-button @click="resetFun">重置</el-button>
            <toolbar style="margin-left:10px ;" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <!--列表-->
    <el-table :data="tableList" highlight-current-row element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
      @selection-change="selectCurrentRow" style="width: 100%" border>
      <el-table-column type="selection" width="50" fixed align="center"></el-table-column>
      <el-table-column label="标记" width="150" align="center">
        <template slot-scope="scoped">
          <p>{{scoped.row.resellerName}}</p>
          <p>
            <el-tag size="mini" v-if="scoped.row.isHaveAfterOrder && scoped.row.outOrderNo" effect="dark" type="danger">外部订单有售后订单</el-tag>
          </p>
        </template>
      </el-table-column>
      <el-table-column label="子订单号" width="200" align="center">
        <template slot-scope="scope">
          {{ scope.row.orderNo }}
        </template>
      </el-table-column>
      <el-table-column prop="resellerName" label="订单来源" width="120" align="center"></el-table-column>
      <el-table-column prop="status" label="订单状态" align="center" min-width="300">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">待采购订单</span>
          <span v-if="scope.row.status == 2">待发货订单</span>
          <span v-if="scope.row.status == 3">待收货订单</span>
          <span v-if="scope.row.status == 4">已发货订单</span>
        </template>
      </el-table-column>
      <el-table-column prop="outOrderNo" label="外部订单号" width="200" align="center"></el-table-column>
      <el-table-column label="商品信息" width="500" align="center">
        <template slot-scope="scope">
          <span style="display: inline-block;margin-right:10px;">{{
              scope.row.orderItems && scope.row.orderItems[0] &&
              scope.row.orderItems[0].productSkuName
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="商品规格" align="center" width="120">
        <template slot-scope="scope">
          <span style="display: inline-block;margin-right:10px;">{{
              scope.row.orderItems && scope.row.orderItems[0] &&
              scope.row.orderItems[0].productSpecExt ? scope.row.orderItems[0].productSpecExt : scope.row.orderItems[0].productSpec
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="supplierName" label="商品供应商" width="120" align="center">
        <!--          <template slot-scope="scope">-->
        <!--                        <span-->
        <!--                            style="display: inline-block;margin-right:10px;"> {{-->
        <!--                            scope.row.orderPurchases &&   scope.row.orderPurchases[0] && scope.row.orderPurchases[0].productSupplierName-->
        <!--                          }}</span>-->
        <!--          </template>-->
      </el-table-column>
      <el-table-column label="商品价格" width="120" align="center">
        <template slot-scope="scope">
          <span style="display: inline-block;margin-right:10px;">{{
              scope.row.orderItems && scope.row.orderItems[0] &&
              scope.row.orderItems[0].unitPrice
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="orderQuantity" label="数量" width="120" align="center">
        <!--          <template slot-scope="scope">-->
        <!--            <span style="display: inline-block;margin-right:10px;">{{-->
        <!--                scope.row.orderItems && scope.row.orderItems[0] &&-->
        <!--                scope.row.orderItems[0].quantity-->
        <!--              }}</span>-->
        <!--          </template>-->
      </el-table-column>
      <el-table-column prop="payTotalAccount" label="订单金额" width="200" align="center">
        <!--          <template slot-scope="scope">-->
        <!--            {{-->
        <!--              (scope.row.orderItems && scope.row.orderItems[0] && scope.row.orderItems[0].unitPrice) *-->
        <!--              (scope.row.orderItems && scope.row.orderItems[0] && scope.row.orderItems[0].quantity)-->
        <!--            }}-->
        <!--            {{scope.row.purchasePrice * scope.row.purchaseQuantity}}-->
        <!--          </template>-->
      </el-table-column>
      <!--        <el-table-column prop="" label="优惠信息" width="200" align="center">-->
      <!--          <template slot-scope="scope">-->
      <!--            {{-->
      <!--              (scope.row.purchaseQuantity) * (scope.row.purchasePrice) - -->
      <!--              (scope.row.orderItems && scope.row.orderPurchases[0] && scope.row.orderPurchases[0].purchaseQuantity) *-->
      <!--              (scope.row.orderItems && scope.row.orderItems[0] && scope.row.orderItems[0].costPrice)-->
      <!--            }}-->
      <!--          </template>-->
      <!--        </el-table-column>-->
      <el-table-column prop="payTotalAccount" label="实付金额" width="200" align="center">
        <!--          <template slot-scope="scope">-->
        <!--            {{-->
        <!--              (scope.row.orderItems && scope.row.orderItems[0] && scope.row.orderItems[0].unitPrice) *-->
        <!--              (scope.row.orderItems && scope.row.orderItems[0] && scope.row.orderItems[0].quantity)-->
        <!--            }}-->
        <!--          </template>-->
      </el-table-column>
      <el-table-column prop="" label="收货信息" width="500" align="center">
        <template slot-scope="scope">
          <span style="display: inline-block;margin-right:10px;"> {{ scope.row.receivingName }}</span>
          <span style="display: inline-block;margin-right:10px;"> {{ scope.row.receivingMobile }}</span>
          <span style="display: inline-block;margin-right:10px;"> {{ scope.row.receivingProviceName }},
            {{ scope.row.receivingCityName }},{{ scope.row.receivingDistrictName }},{{
                scope.row.receivingStreetName
            }}，{{ scope.row.receivingAddress }}</span>
        </template>
      </el-table-column>
      <el-table-column label="待采购数量" width="200" align="center">
        <template slot-scope="scope">
          <!--/*            <span style="display: inline-block;margin-right:10px;">*/-->
          <!--              {{-->
          <!--               (scope.row.orderPurchases && scope.row.orderPurchases[0] &&-->
          <!--                    scope.row.orderPurchases[0].purchaseQuantity)-->
          <!--              }}</span>-->
          <!--            purchaseQuantity  已采购数量-->
          {{ scope.row.orderQuantity - scope.row.purchasedQuantity }}
        </template>
      </el-table-column>
      <el-table-column label="采购供应商" width="300" align="center">
        <template slot-scope="scope">

          <el-autocomplete v-model="scope.row.supplierName" :fetch-suggestions="querySearchAsync"
            placeholder="请选择供应商 可搜索" @select="((val) => { handleSelect1(val, scope.$index, scope.row) })">
          </el-autocomplete>
        </template>
      </el-table-column>
      <el-table-column prop="purchasePrice" label="采购价" width="200" align="center">

        <!--          <template slot-scope="scope">-->
        <!--            <span style="display: inline-block;margin-right:10px;">-->
        <!--              {{-->
        <!--                scope.row.orderPurchases && scope.row.orderPurchases[0] &&-->
        <!--                scope.row.orderPurchases[0].purchasePrice-->
        <!--              }}</span>-->
        <!--          </template>-->

      </el-table-column>
      <!--        <el-table-column label="采购数量" width="200" align="center">-->
      <!--          <template slot-scope="scope">-->
      <!--            <el-input style="width:100px;" v-model="scope.row.waitPurchaseQuantity"-->
      <!--                      @input="(val) => getTotal(val, scope.row)"></el-input>-->
      <!--          </template>-->
      <!--        </el-table-column>-->
      <el-table-column prop="waitPurchaseQuantity" label="采购数量" width="200" align="center">
        <template slot-scope="scope">
          <el-input @input="(val) => checkVal(val, scope.row)" style="width:100px;"
            v-model="scope.row.waitPurchaseQuantity"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="采购合计" width="200" align="center">
        <template slot-scope="scope">
          <!--            {{ scope.row.orderPurchases[0].purchaseTotal }}-->
          {{ scope.row.purchaseTotal }}
        </template>

      </el-table-column>
      <el-table-column width="200" label="操作" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"
            @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]" class="pagination">
    </el-pagination>
    <!-- 导入物流信息 -->
    <el-dialog title="导入物流信息" width="30%" :visible.sync="logisticsVisible" :show-file-list="false"
      :close-on-click-modal="false">
      <div class="updata_view" v-loading="uploading" element-loading-text="正在上传...">
        <el-upload class="upload-demo" drag action="#" :auto-upload="false" :on-change="updataLogistics"
          :on-remove="removeLogistics">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            只能上传xlsx文件
            <el-button type="text" @click="upDataInfo()">下载导入模板
            </el-button>
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-preventClick @click="handleExpSubmit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  OrderPurchaseGetAll,
  BatchPurchase,
  BatchCreate1,
  SupplierGetAll, PropertyValueDelete,
  OrderExport,
  OrderLogisticUpload
} from "../../../api/api";
import { getButtonList } from "../../../promissionRouter";
import Toolbar from "../../../components/Toolbar";
import MyDialog from "../../../components/MyDialog";

export default {
  components: { Toolbar },
  data() {
    return {
      searchData: {
        PageIndex: 1, //页码
        PageSize: 10, //页长
        orderNo: null,
        productSkuName: null,
        receivingName: null,
        receivingMobile: null,
        supplierName: null,
        Status: 1,
        OutOrderNo: "",
        CreationStartTime: "",
        CreationEndTime: ""
      },
      datePicker: [],
      total: 0,
      listLoading: false,
      buttonList_toolBar: [],
      buttonList_table: [],
      tableList: [],
      supplierList: [{
        value: '1',
        label: '黄金糕'
      }, {
        value: '2',
        label: '双皮奶'
      }, {
        value: '3',
        label: '蚵仔煎'
      }, {
        value: '4',
        label: '龙须面'
      }, {
        value: '5',
        label: '北京烤鸭'
      }],
      temp: '',
      SupplierName: '',
      nu: 0,
      logisticsVisible: false,
      uploading: false,
      fileLog: null,
    };
  },
  created() {
    this.getPurchaseList();
    this.getBrandList();
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      this.buttonList_toolBar = toolBarButtonList;
      const tableButtonList = buttonList.filter((item) => {
        return item.buttonShow === 20;
      });
      this.buttonList_table = tableButtonList;
    }
  },
  methods: {
    checkVal(val, row) {
      console.log('val', val, row)
      // if (!isNaN(val)){
      //   return this.$message.error('输入有误, 请重试')
      // }
      // let maxNum = Number(row.waitPurchaseQuantity);
      //
      // if (Number(val) <=0){
      //   return this.$message.error('采购数量有误, 请重试')
      // }
      //
      // if (Number(val) > maxNum){
      //   return this.$message.error(`当前采购数量不得大于待采购数量${maxNum}`)
      // }
    },
    exportBtn() {
      let SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      this.searchData.SkipCount = SkipCount;
      this.searchData.MaxResultCount = this.searchData.PageSize;
      OrderExport(this.searchData).then(res => {
        console.log('--', res)
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
        let objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.download = '订单列表数据.xlsx'
        a.href = objectUrl
        a.click()
        a.remove()
      })
    },
    importBtn() {
      this.logisticsVisible = true;
      this.fileLog = null;
    },
    upDataInfo() {
      window.open(
        "https://homeimage.ksaxshop.com/erp/order/%E8%AE%A2%E5%8D%95%E7%89%A9%E6%B5%81%E5%AF%BC%E5%85%A5.xlsx"
      );
    },
    updataLogistics(e) {
      let that = this;
      let index1 = e.raw.name.lastIndexOf(".") + 1;
      let index2 = e.raw.name.length;
      let type = e.raw.name.substring(index1, index2);
      if (type != "xlsx")
        return that.$message.error("请上传文件格式为xlsx文件");
      that.fileLog = e.raw;
    },
    removeLogistics() {
      this.fileLog = null;
    },
    handleExpSubmit() {
      this.uploading = true;
      let formData = new window.FormData();
      formData.append("file", this.fileLog);
      OrderLogisticUpload(formData).then((res) => {
        if (!res.data.result) {
          this.$message.success('上传成功！');
          this.uploading = false;
          this.logisticsVisible = false;
          this.fileLog = null;
          this.getTableList();
        } else {
          this.$message.error(res.data.result);
          this.uploading = false;
        }
      });
    },
    getTotal(val, row) {
      console.log(val, row)
      let num = row.orderQuantity - row.purchaseQuantity;

      let check = val - num;

      console.log('val', val);
      console.log('num', num);
      this.$nextTick(() => {

        if (val <= 0) {
          return this.$message.error('采购数量必须大于等于0')
        }

        if (val > num) {
          return this.$message.error('采购数量不能大于待采购数量')
        }
      })
    },
    batchPurchase() {

    },
    handlePurchase(button, index, row) {
      console.log('row-------', row)
      this.$confirm("确认提交采购吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(async () => {
        // console.log('提交采购row', row); return;
        // orderId  productSupplierId  purchaseQuantity  purchaseTotal  purchasePrice  orderNo  productSupplierName id
        let params = {};
        params.orderId = row.id;
        params.productSupplierId = row.sourceId;
        params.purchaseQuantity = row.waitPurchaseQuantity;
        params.purchaseTotal = row.purchaseTotal;
        params.purchasePrice = row.purchasePrice;
        params.orderNo = row.orderNo;
        params.productSupplierName = row.supplierName;
        // console.log('提交采购params', params); return;
        let res = await BatchCreate1([params]);
        console.log('提交采购', res);
        if (res.data.success) {
          this.$message.success('发货成功');
          this.searchData.PageIndex = 1;
          await this.getPurchaseList();
        } else {
          this.$message.error(res.data.error.message || '采购失败, 请重试')
        }
      }).catch(() => {
      });

    },
    handleSelect(item) {
      console.log('item', item);
      this.searchData.supplierName = item.value;
      // console.log('item', item);
      // this.searchData.brandId = item.id;
    },
    handleSelect1(item, index, row) {
      console.log('item, index', item, index)
      // console.log('item', item);
      // this.searchData.brandId = item.id;
      this.$set(this.tableList[index], 'sourceId', item.id);
      this.$set(this.tableList[index], 'supplierName', item.value);
      console.log('this.tableList[index]', this.tableList[index]);
    },
    selectCurrentRow() {
    },
    async querySearchAsync(queryString, cb) {
      if (queryString) {
        let res = await this.getBrandList(queryString);
        cb(res);
      } else {
        let res = await this.getBrandList();
        cb(res);
      }
    },
    orderDetail(item, index, row) {
      // this.$router.push(
      //   `/OrderManagement/Purchasing/OrderDetail?id=${row.id}`
      // );
    },
    beforeRouteEnter(to, from, next) {
      if (from.path == "/OrderManagement/Purchasing/OrderDetail?id") {
        to.meta.keepAlive = true;
      } else {
        to.meta.keepAlive = false;
      }
      next();
    },

    async getBrandList(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100,
      };
      if (key) {
        obj.supplierName = key;
      }
      return new Promise((resolve, reject) => {
        SupplierGetAll(obj).then((res) => {
          console.log('供应商列表', res);
          if (res.data.success) {
            this.brandList = res.data.result.items.map((item) => {
              return {
                value: item.proSupplierName,
                id: item.id,
              };
            });
            resolve(this.brandList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },

    searchFun() {
      this.PageIndex = 1;
      this.getPurchaseList();

    },
    resetFun() {
      this.datePicker = []
      this.searchData = {
        PageIndex: 1, //页码
        PageSize: 10, //页长
        orderNo: null,
        productSkuName: null,
        receivingName: null,
        receivingMobile: null,
        supplierName: null,
        Status: 1,
        OutOrderNo: ""
      };
      this.getPurchaseList();
    },
    handlePicker(val) {
      if (!val) {
        this.searchData.CreationStartTime = ""
        this.searchData.CreationEndTime = ""
      } else {
        this.searchData.CreationStartTime = val[0]
        this.searchData.CreationEndTime = val[1]
      }
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    handleCurrentChange(val) {
      this.searchData.PageIndex = val;

      this.getPurchaseList();
    },
    handleSizeChange(e) {
      this.searchData.PageSize = e;
      this.getPurchaseList();
    },
    //获取采购列表
    async getPurchaseList() {
      this.listLoading = true;
      // let SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      this.searchData.SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      this.searchData.MaxResultCount = this.searchData.PageSize;
      console.log('searchData', this.searchData);
      // return;
      let res = await OrderPurchaseGetAll(this.searchData);
      if (res.data.success) {
        this.total = res.data.result.totalCount;
        this.tableList = res.data.result.items;
      } else {
        this.$message.error(res.data.msg)
      }
      setTimeout(() => {
        this.listLoading = false;
      }, 500)
      console.log('待采购列表', res);
    },
    handleEdit(item, index, row) {
      this.$router.push(`/Product/AddEditSpu?id=${row.id}`)
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   if (from.path == "/Product/ComManagement/EditProduct") {
  //     to.meta.keepAlive = true;
  //   } else {
  //     to.meta.keepAlive = false;
  //   }
  //   next();
  // },
};
</script>

<style scoped>
.updata_view {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
